import React from "react";
import Book from "./ui/Book";
import { books } from "../../data";

const Discounted = () => {
  return (
    <section id="discounted">
      <div className="container">
        <div className="row">
          <h2 className="section__title">
            Discounted <span className="purple">Books</span>
          </h2>
          <div className="books">
            {books
              .filter((book) => book.salePrice != null)
              .slice(0, 8)
              .map((book) => (
                <Book
                  key={book.id}
                  id={book.id}
                  imgSrc={book.url}
                  title={book.title}
                  rating={book.rating}
                  normalPrice={book.originalPrice}
                  salePrice={book.salePrice}
                />
              ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Discounted;
